// extracted by mini-css-extract-plugin
export default {"container":"statistics-comparison-panel_container__m3Iro"};